import EmailField from './EmailField.component';

export default EmailField;
